<select SelectUi *ngIf="control" [formControl]="control" (change)="idChange.emit($event.target.value)">
    <option [value]="s.id" *ngFor="let s of country.items">{{s.name}}</option>
</select>

<select SelectUi *ngIf="!control" [(ngModel)]="id" (change)="idChange.emit($event.target.value)">
    <option [value]="s.id" *ngFor="let s of country.items">{{s.name}}</option>
</select>
<img class="position-absolute imaag" src="../../../../../assets/images/icon_drop down.png">